import React, { useCallback } from "react";
import PropTypes from "prop-types";
import "./status-needs-cleaning.scss";

const StatusNeedsCleaning = ({ showModal, deviceUUID }) => {
  const handleClick = useCallback(() => {
    if (showModal) {
      showModal(deviceUUID);
    }
  }, [showModal, deviceUUID]);

  return (
    <div onClick={handleClick} className="device__status--needs-cleaning">
      <span className="ion-waterdrop device__alert-icon" />
      <span className="device__alert-text"> Device needs cleaning </span>
      <span className="ion-ios-arrow-right device__chevron" />
    </div>
  );
};

StatusNeedsCleaning.propTypes = {
  showModal: PropTypes.func.isRequired,
  deviceUUID: PropTypes.string.isRequired,
};

export default StatusNeedsCleaning;
